import dayjs from "dayjs";

require('dayjs/locale/ru')
dayjs.locale("ru")
